import {connect} from "react-redux"
import {IncomingHttpHeaders} from "http"
import State from "../../ducks/state"
import {REALM_HEADER} from "../../config/constants"

export const mapStateToProps = (state: State) => {
    const realm = (state.request.headers as IncomingHttpHeaders)[REALM_HEADER] as string
    const {
        settings: {variant},
    } = state

    return {
        realm,
        chevronIconAltText: state.text.chevron.chevronIconAltText,
        variant,
        templating: state.template,
    }
}

export default connect(mapStateToProps)
